import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';

export const CONFIGURATION_SLICE_KEY = 'configuration';

/* Defines a Redux slice named `configuration` to share the configuration data across the application. */
const configurationSlice = createSlice({
  name: CONFIGURATION_SLICE_KEY,
  initialState: {
    resourceDomain: null,
    loading: LoadingStatus.Idle.toString(),
    error: null,
  },
  reducers: {
    fetchConfiguration: (state) => {
      state.loading = LoadingStatus.Loading.toString();
    },
    fetchConfigurationError: (state, action) => {
      state.loading = LoadingStatus.Failed.toString();
      state.error = action.payload;
    },
    fetchConfigurationFulfilled: (state, action) => {
      state.reCaptchaSiteKey = action.payload.ReCaptchaSiteKey;
      state.googleOneTapClientId = action.payload.GoogleOneTapClientId;
      state.imageResizeService = action.payload.IRSDomain;
      state.isMarkerAutoScrollFeatureEnabled = action.payload.IsMarkerAutoScrollFeatureEnabled;
      state.resourceDomain = action.payload.ResourceDomain;
      state.segmentApiKey = action.payload.SegmentApiKey;
      state.loading = LoadingStatus.Succeeded.toString();
      state.error = null;
    },
  },
});

export default configurationSlice;
